// ContactPage.jsx - FIXED CSS/HTML MATCH

import React, { useState } from 'react';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import Header from '../components/Header';
import { useLanguage } from '../context/LanguageContext';
import { content } from '../data/content';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import ScrollToTop from '../components/ScrollToTop';

const ContactPage = () => {
  const { language } = useLanguage();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    service: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const access_key = process.env.REACT_APP_WEB3FORMS_KEY;
    const formDataToSend = new FormData();
    formDataToSend.append('access_key', access_key); 
    formDataToSend.append('name', formData.name);
    formDataToSend.append('phone', formData.phone);
    formDataToSend.append('service', formData.service);
    formDataToSend.append('message', formData.message);

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formDataToSend,
        headers: { 'Accept': 'application/json' }
      });
   
      if (!response.ok) {
        setError('There was an error submitting the form. Please try again later.');
        return;
      }

      const result = await response.json();
      if (result.success) {
        setSubmitted(true);
        setTimeout(() => {
          setSubmitted(false);
          setFormData({ name: '', phone: '', service: '', message: '' });
        }, 3000);
      } else {
        setError('There was an error submitting the form. Please try again later.');
      }
    } catch (err) {
      console.error('Error during fetch:', err);
      setError('There was an error submitting the form. Please try again later.');
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const t = content?.[language]?.contact || {
    title: language === 'mr' ? 'संपर्क साधा' : 'Contact Us',
    subtitle: language === 'mr' ? 'आम्हाला संदेश पाठवा' : 'Send us a message',
    address: 'Thane, Maharashtra, India',
    phone: '+91 88504 15838',
    email: 'admin@shreeservz.com',
    hours: language === 'mr' ? 'सोम-शनि: 10AM-8PM' : 'Mon-Sat: 10AM-8PM'
  };

  return (
    <>
      <style>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .contact-page {
          min-height: 100vh;
          background: #f9fafb;
        }

        .contact-hero {
          background: linear-gradient(-45deg, #c94b4b, #4b134f, #1e3a8a, #065f46);
          background-size: 400% 400%;
          animation: gradientShift 15s ease infinite;
          padding: 100px 0 80px;
          color: white;
          text-align: center;
          position: relative;
          overflow: hidden;
        }

        @keyframes gradientShift {
          0% { background-position: 0% 50%; }
          50% { background-position: 100% 50%; }
          100% { background-position: 0% 50%; }
        }

        .contact-hero::before {
          content: '';
          position: absolute; 
          top: -100%;
          right: -10%;
          width: 500px;
          height: 500px;
          background: rgba(255, 255, 255, 0.1);
          border-radius: 50%;
        }

        .contact-hero::after {
          content: '';
          position: absolute;
          bottom: -70%;
          left: -5%;
          width: 400px;
          height: 400px;
          background: rgba(255, 255, 255, 0.08);
          border-radius: 50%;
        }

        .contact-hero h1 {
          font-size: 48px;
          margin-bottom: 16px;
          font-weight: 700;
          position: relative;
          z-index: 1;
        }

        .contact-hero p {
          font-size: 20px;
          opacity: 0.95;
          max-width: 600px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        .contact-content {
          max-width: 1200px;
          margin: -40px auto 0;
          padding: 0 20px 80px;
          position: relative;
          z-index: 1;
        }

        .contact-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 30px;
        }

        .contact-form-card,
        .contact-info-section {
          background: white;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          padding: 40px;
        }

        .contact-form-card h2,
        .contact-info-section h2 {
          font-size: 28px;
    color: #1a1a1a;
    margin-bottom: 16px;
    font-weight: 700;
    background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
        }

        /* ✅ FIXED: Added .form-header styles */
        .form-header {
          margin-bottom: 24px;
        }

        .form-header h3 {
          font-size: 20px;
          color: #1a1a1a;
          margin-bottom: 8px;
          font-weight: 600;
        }

        .form-header p {
          font-size: 14px;
          color: #666;
        }

        .form-group {
          margin-bottom: 24px;
        }

        .form-group label {
          display: block;
          margin-bottom: 8px;
          color: #333;
          font-weight: 600;
          font-size: 14px;
        }

        .form-group input,
        .form-group textarea,
        .form-group select {
          width: 100%;
          padding: 14px 16px;
          border: 2px solid #e5e7eb;
          border-radius: 12px;
          font-size: 15px;
          transition: all 0.3s ease;
          font-family: inherit;
        }

        .form-group input:focus,
        .form-group textarea:focus,
        .form-group select:focus {
          outline: none;
          border-color: #667eea;
          box-shadow: 0 0 0 4px rgba(102, 126, 234, 0.1);
        }

        .form-group textarea {
          resize: vertical;
          min-height: 120px;
        }

        /* ✅ FIXED: Added select-specific styles */
        .form-group select {
          cursor: pointer;
          background-color: white;
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23333' d='M6 9L1 4h10z'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 16px center;
          padding-right: 40px;
          appearance: none;
        }

        .submit-button {
          width: 100%;
          padding: 16px;
          background: #ff6b35;
          color: white;
          border: none;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
        }

        .submit-button:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(255, 107, 53, 0.3);
          background: #e55a2b;
        }

        .submit-button:active {
          transform: translateY(0);
        }

        /* ✅ FIXED: Added .success-message styles */
        .success-message {
          text-align: center;
          padding: 40px 20px;
          animation: fadeInScale 0.5s ease;
        }

        .success-message h4 {
          font-size: 24px;
          color: #28a745;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
        }

        .success-message p {
          color: #666;
          font-size: 16px;
          line-height: 1.6;
        }

        @keyframes fadeInScale {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .contact-info-cards {
          display: grid;
          gap: 20px;
        }

        .info-card {
          display: flex;
          gap: 20px;
          padding: 24px;
          background: #f9fafb;
          border-radius: 16px;
          transition: all 0.3s ease;
        }

        .info-card:hover {
          background: #f3f4f6;
          transform: translateX(5px);
        }

        .info-icon {
          width: 60px;
          height: 60px;
          background: linear-gradient(135deg, #fff5f2 0%, #ffe5dc 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .info-content h3 {
          font-size: 16px;
          color: #1a1a1a;
          margin-bottom: 6px;
          font-weight: 600;
        }

        .info-content p {
          color: #666;
          font-size: 15px;
          line-height: 1.6;
        }

        .map-section {
          margin-top: 30px;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        }

        .map-section iframe {
          width: 100%;
          height: 450px;
          border: none;
          display: block;
        }

        .additional-info {
          margin-top: 30px;
          padding: 30px;
          background: white;
          border-radius: 20px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
          text-align: center;
        }

        .additional-info h3 {
          font-size: 24px;
          color: #1a1a1a;
          margin-bottom: 12px;
    font-weight: 700;
    background: linear-gradient(135deg, #1a1a1a 0%, #ff6b35 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
        }

        .additional-info p {
          color: #666;
          line-height: 1.8;
          max-width: 800px;
          margin: 0 auto;
        }

        /* ✅ FIXED: Added error message styles */
        .error-message {
          padding: 12px 16px;
          background: #f8d7da;
          color: #721c24;
          border: 1px solid #f5c6cb;
          border-radius: 8px;
          margin-bottom: 20px;
          font-size: 14px;
        }

        @media (max-width: 968px) {
          .contact-grid {
            grid-template-columns: 1fr;
          }

          .contact-hero {
            padding: 80px 0 60px;
          }

          .contact-hero h1 {
            font-size: 36px;
          }

          .contact-hero p {
            font-size: 18px;
          }

          .contact-form-card,
          .contact-info-section {
            padding: 30px 20px;
          }
        }

        @media (max-width: 480px) {
          .contact-hero h1 {
            font-size: 28px;
          }

          .info-card {
            flex-direction: column;
            text-align: center;
          }

          .info-icon {
            margin: 0 auto;
          }

          .form-group input,
          .form-group textarea,
          .form-group select {
            font-size: 16px; /* Prevents zoom on iOS */
          }
        }
      `}</style>

      <div className="contact-page">
        <Header content={content} />
        
        {/* Hero Section */}
        <div className="contact-hero">
          <h1>{t.title}</h1>
          <p>{t.subtitle}</p>
        </div>

        {/* Main Content */}
        <div className="contact-content">
          <div className="contact-grid">
            {/* Contact Form */}
            <div className="contact-form-card">
              <h2>
                {language === 'mr' ? 'संदेश पाठवा' : 'Send us a Message'}
              </h2>
              
              {!submitted ? (
                <>
                  {/* ✅ FIXED: Added .form-header wrapper */}
                  {/* <div className="form-header">
                    <h3>{language === 'mr' ? 'संदेश पाठवा' : 'Send us a Message'}</h3>
                    <p>{language === 'mr' ? 'खालील फॉर्म भरा' : 'Fill out the form below'}</p>
                  </div> */}

                  {/* ✅ FIXED: Added error display */}
                  {error && (
                    <div className="error-message">
                      {error}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div className="form-group">
                      <label>{language === 'mr' ? 'तुमचे नाव' : 'Your Name'} *</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        required
                        placeholder={language === 'mr' ? 'तुमचे पूर्ण नाव' : 'Enter your Full Name'}
                      />
                    </div>

                    <div className="form-group">
                      <label>{language === 'mr' ? 'फोन नंबर' : 'Phone Number'} *</label>
                      <input
                        type="tel"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        required
                        pattern="[0-9]{10}"
                        placeholder={language === 'mr' ? 'तुमचा फोन नंबर' : 'Enter your Phone Number'}
                      />
                    </div>

                    <div className="form-group">
                      <label>{language === 'mr' ? 'सेवा निवडा' : 'Select Service'} *</label>
                      <select
                        name="service"
                        value={formData.service}
                        onChange={handleChange}
                        required
                      >
                        <option value="">{language === 'mr' ? 'सेवा निवडा' : 'Choose a service'}</option>
                        <option value={language === 'mr' ? 'पासपोर्ट' : 'Passport'}>
                          {language === 'mr' ? 'पासपोर्ट' : 'Passport'}
                        </option>
                        <option value={language === 'mr' ? 'पॅन कार्ड' : 'PAN Card'}>
                          {language === 'mr' ? 'पॅन कार्ड' : 'PAN Card'}
                        </option>
                        <option value={language === 'mr' ? 'आधार कार्ड' : 'Aadhar Card'}>
                          {language === 'mr' ? 'आधार कार्ड' : 'Aadhar Card'}
                        </option>
                        <option value={language === 'mr' ? 'ड्रायव्हिंग लायसन्स' : 'Driving License'}>
                          {language === 'mr' ? 'ड्रायव्हिंग लायसन्स' : 'Driving License'}
                        </option>
                        <option value={language === 'mr' ? 'इतर' : 'Other'}>
                          {language === 'mr' ? 'इतर' : 'Other'}
                        </option>
                      </select>
                    </div>

                    <div className="form-group">
                      <label>{language === 'mr' ? 'संदेश' : 'Message'}</label>
                      <textarea
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder={language === 'mr' ? 'काही विशेष माहिती...' : 'Any specific requirements...'}
                      />
                    </div>

                    <button type="submit" className="submit-button">
                      <Send size={18} />
                      {language === 'mr' ? 'संदेश पाठवा' : 'Send Message'}
                    </button>
                  </form>
                </>
              ) : (
                /* ✅ FIXED: Now .success-message has matching CSS */
                <div className="success-message">
                  <h4>✓ {language === 'mr' ? 'संदेश यशस्वीरित्या पाठवला!' : 'Message Sent Successfully!'}</h4>
                  <p>
                    {language === 'mr' 
                      ? 'आम्ही २४ तासांत तुमच्याशी संपर्क साधू.' 
                      : 'We will contact you within 24 hours.'}
                  </p>
                </div>
              )}
            </div>

            {/* Contact Information */}
            <div className="contact-info-section">
              <h2>
                {language === 'mr' ? 'संपर्क माहिती' : 'Contact Information'}
              </h2>
              <div className="contact-info-cards">
                <div className="info-card">
                  <div className="info-icon">
                    <MapPin color="#ff6b35" size={28} />
                  </div>
                  <div className="info-content">
                    <h3>{language === 'mr' ? 'पत्ता' : 'Address'}</h3>
                    <p>{t.address}</p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <Phone color="#ff6b35" size={28} />
                  </div>
                  <div className="info-content">
                    <h3>{language === 'mr' ? 'फोन' : 'Phone'}</h3>
                    <p>{t.phone}</p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <Mail color="#ff6b35" size={28} />
                  </div>
                  <div className="info-content">
                    <h3>{language === 'mr' ? 'ईमेल' : 'Email'}</h3>
                    <p>{t.email}</p>
                  </div>
                </div>

                <div className="info-card">
                  <div className="info-icon">
                    <Clock color="#ff6b35" size={28} />
                  </div>
                  <div className="info-content">
                    <h3>{language === 'mr' ? 'कार्यालयीन वेळ' : 'Business Hours'}</h3>
                    <p>{t.hours}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Map Section */}
          <div className="map-section">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d60288.71434102667!2d72.9764739417712!3d19.193252231726778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7bf8a00230155%3A0xc0bcc84fd31a6666!2sShree%20Enterprises!5e0!3m2!1sen!2sin!4v1764085269928!5m2!1sen!2sin" 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Location Map"
            />
          </div>

          {/* Additional Info */}
          <div className="additional-info">
            <h3>
              {language === 'mr' ? 'आम्ही मदतीसाठी येथे आहोत' : 'We\'re Here to Help'}
            </h3>
            <p>
              {language === 'mr' 
                ? 'तुमच्या सर्व दस्तऐवज आवश्यकतांसाठी आम्ही तुम्हाला मदत करण्यासाठी येथे आहोत. आजच आमच्याशी संपर्क साधा आणि आम्ही तुमच्या प्रश्नांची उत्तरे देऊ.'
                : 'We\'re here to assist you with all your documentation needs. Reach out to us today and we\'ll be happy to answer your questions and provide the services you need.'}
            </p>
          </div>
        </div>
      </div>
      <Footer language={language}/>
      <WhatsAppButton phoneNumber="918850415838" message="Hello, I need help with a service" />
      <ScrollToTop />
    </>
  );
};

export default ContactPage;